import PricePriceSale from './section/price-sale';
import PriceOriginal from './section/price-original';
import { i18N } from "../helper";
AC_SERVICES.addListener('Editing.Editables.Ready', (Editables) => {
    const Abstract = Editables.get('_abstract');
    const Types = {
        REGULAR: 'regular',
        SALE: 'sale'
    };
    class PriceSmart extends Abstract {
        getEditableType() {
            return 'wc_price_extended';
        }
        constructor(args) {
            super(args);
            this.PriceOriginal = new PriceOriginal();
            this.PriceOriginal.init();
            this.PriceSale = new PricePriceSale();
            this.PriceSale.init();
        }
        focus() {
            this.getElement().querySelector('[name=price_type]').focus();
        }
        render() {
            this.getElement().querySelector('.aceditable__form__inputs').append(this.PriceOriginal.getElement());
            this.getElement().querySelector('.aceditable__form__inputs').append(this.PriceSale.getElement());
            this.PriceOriginal.show();
            this.PriceSale.hide();
            this.attachEvents();
            if (this.settings.default_type === Types.SALE) {
                this.switchToType(Types.SALE);
            }
        }
        getPriceTypeElements() {
            return this.getElement().querySelectorAll('[name=price_type]');
        }
        getPriceType() {
            return this.getElement().querySelector('[name=price_type]:checked').value;
        }
        switchToType(type) {
            this.getPriceTypeElements().forEach((e) => {
                e.checked = false;
                if (e.value === type) {
                    e.checked = true;
                    e.dispatchEvent(new Event('change'));
                }
            });
        }
        attachEvents() {
            this.getPriceTypeElements().forEach(el => {
                el.addEventListener('change', () => {
                    switch (this.getPriceType()) {
                        case Types.REGULAR:
                            this.PriceOriginal.show();
                            this.PriceSale.hide();
                            break;
                        case Types.SALE:
                            this.PriceOriginal.hide();
                            this.PriceSale.show();
                            break;
                    }
                });
            });
        }
        getValue() {
            let value = {};
            let type = this.getPriceType();
            switch (type) {
                case Types.REGULAR:
                    value = this.PriceOriginal.getValue();
                    break;
                case Types.SALE:
                    value = this.PriceSale.getValue();
                    break;
            }
            value.type = type;
            return value;
        }
        valueToInput(value) {
            if (!value) {
                return;
            }
            if (value.hasOwnProperty('regular')) {
                this.PriceOriginal.setValue(value.regular);
            }
            if (value.hasOwnProperty('sale')) {
                this.PriceSale.setValue(value.sale);
            }
        }
        getTemplate() {
            return `
			<div class="pricetype">
				<label class="pricetype__label"><input type="radio" name="price_type" value="regular" checked> ${i18N().regular_price}</label>
				<label class="pricetype__label"><input type="radio" name="price_type" value="sale"> ${i18N().sale_price}</label>
			</div>
			`;
        }
    }
    Editables.registerEditable('wc_price_extended', PriceSmart);
});
// Register MiddleWare
AC_SERVICES.addListener('Editing.Middleware.Ready', (Middleware) => {
    const Abstract = Middleware.getClass('_abstract');
    class PriceSmart extends Abstract {
        getEditable() {
            return this.Editables.get('wc_price_extended');
        }
        map() {
            this.args.default_type = this.settings.default_type;
            return this.args;
        }
    }
    Middleware.register('wc_price_extended', PriceSmart);
});
